import * as React from "react";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Logout from "@mui/icons-material/Logout";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import MenuIcon from "@mui/icons-material/Menu";
import {
  Box,
  Button,
  Divider,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router";
import { usePageTitle } from "./PageTitleProvider";
import { Home } from "@mui/icons-material";


const drawerWidth = 300;

interface AppBarPropsCustom extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarPropsCustom>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export interface AppBarProps {
  open: boolean;
  handleDrawerOpen: () => void;
}

export default function MenuAppBar(props: AppBarProps) {
  const theme = useTheme();
  const navigate = useNavigate();
  const { pageTitle } = usePageTitle();
  const isScreenSM = useMediaQuery(theme.breakpoints.down("md"));

  const handleLogout = async () => {
    localStorage.removeItem("token");
    localStorage.removeItem("profile");
    localStorage.removeItem("Login");
    navigate("/", { replace: true });
  };

  return (
    <React.Fragment>
      <ThemeProvider
        theme={createTheme({
          components: {
            MuiListItemButton: {
              defaultProps: {
                disableTouchRipple: true,
              },
            },
          },
          palette: {
            mode: theme.palette.mode,
            background: {
              paper:
                theme.palette.mode === "dark"
                  ? "rgb(37, 37, 38)"
                  : "rgb(255, 255, 255)",
            },
          },
        })}
      >
        <AppBar
          position="fixed"
          sx={{
            backgroundImage: "none",
            boxShadow: "none",
            backgroundColor:
              theme.palette.mode === "light" ? "rgb(255, 255, 255)" : null,
          }}
          open={props.open}
        >
          <Toolbar>
            <IconButton
              aria-label="open drawer"
              onClick={props.handleDrawerOpen}
              sx={{
                ...(props.open && { display: "none" }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <Box
              sx={{
                flexGrow: 1,
                ...(props.open && { display: "none" }),
              }}
            >
              <Stack
                direction="row"
                spacing={2}
                divider={
                  !isScreenSM && <Divider orientation="vertical" flexItem />
                }
              >
                <Button onClick={() => navigate("/reversal")}>
                  <Home />
                </Button>
                <Typography
                  variant="overline"
                  gutterBottom
                  sx={{
                    pt: 2,
                    [theme.breakpoints.down("md")]: { display: "none" },
                  }}
                >
                  {pageTitle}
                </Typography>
              </Stack>
            </Box>

            <Typography
              variant="overline"
              gutterBottom
              sx={{
                flexGrow: 1,
                pt: 1,
                color: theme.palette.mode === "light" ? "#000" : null,
                [theme.breakpoints.down("md")]: { display: "none" },
                ...(!props.open && { display: "none" }),
              }}
            >
              {pageTitle}
            </Typography>
            <IconButton
              onClick={() => {
                handleLogout();
              }}
              color="error"
            >
              <Logout />
            </IconButton>
          </Toolbar>
        </AppBar>
      </ThemeProvider>    
    </React.Fragment>
  );
}
